import { useEffect, useState } from "react";

enum SCREEN_SIZE_TYPES {
    MOBILE = "MOBILE",
    TABLET = "TABLET",
    DESKTOP = "DESKTOP",
}

const SCREEN_SIZE_STATE = {
    [SCREEN_SIZE_TYPES.MOBILE]: {
        mediaQuery: "(max-width: 639px)",
    },
    [SCREEN_SIZE_TYPES.TABLET]: {
        mediaQuery: "(max-width: 1023px)",
    },
    [SCREEN_SIZE_TYPES.DESKTOP]: {
        mediaQuery: "(min-width: 1024px)",
    },
};

function determineScreenSizeType() {
    for (const type in SCREEN_SIZE_TYPES) {
        if (
            window.matchMedia(
                SCREEN_SIZE_STATE[type as SCREEN_SIZE_TYPES].mediaQuery
            ).matches
        ) {
            return type;
        }
    }
}

export const useWindowSize = function () {
    const [screenType, setScreenType] = useState(determineScreenSizeType());

    useEffect(() => {
        const callback = () => {
            setScreenType(determineScreenSizeType);
        };

        for (const type in SCREEN_SIZE_TYPES) {
            window
                .matchMedia(
                    SCREEN_SIZE_STATE[type as SCREEN_SIZE_TYPES].mediaQuery
                )
                .addListener(callback);
        }

        return () => {
            for (const type in SCREEN_SIZE_TYPES) {
                window
                    .matchMedia(
                        SCREEN_SIZE_STATE[type as SCREEN_SIZE_TYPES].mediaQuery
                    )
                    .removeListener(callback);
            }
        };
    }, [setScreenType]);

    return {
        isDesktopScreenSizeFlag: screenType === SCREEN_SIZE_TYPES.DESKTOP,
        isMobileScreenSizeFlag: screenType === SCREEN_SIZE_TYPES.MOBILE,
        isTabletScreenSizeFlag: screenType === SCREEN_SIZE_TYPES.TABLET,
    };
};
